import { createSlice } from "@reduxjs/toolkit";
import {
  TargetListPageEnum
} from "./dto";

interface TargetListState {
  targetListPage: TargetListPageEnum;
}

const initialState: TargetListState = {
  targetListPage: TargetListPageEnum.LIST,
};

const targetListSlice = createSlice({
  name: "targetList/slice",
  initialState,
  extraReducers(builder) {
  },
  reducers: {
    setTargetListPage: (state, action) => {
      state.targetListPage = action.payload;
    },
  },
});

export const {
  setTargetListPage,
} = targetListSlice.actions;

export default targetListSlice.reducer;
